import React, { useEffect } from 'react';
import { setManufacturerId } from 'redux/services/donaldGrump/releasedProductsParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../Inputs';

export const ManufacturerFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setManufacturerId(value || undefined));
  }, 500);

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setManufacturerId(undefined));
    };
  }, [dispatch]);

  return <FancyInput placeholder="Manufacturer" onChange={handleChange} />;
};
